<template>
  <div class="eandup-page">
    <!-- Header -->
    <div class="ed-header">
      <div>
        <span class="header-eyebrow">Shopify</span>
        <h2 class="header-title">EAN Duplicados</h2>
      </div>
    </div>

    <!-- KPI Strip -->
    <div class="kpi-strip">
      <div class="kpi-card">
        <span class="kpi-label">Duplicados</span>
        <span class="kpi-value" :class="productosEanDuplicado.length > 0 ? 'kpi-value--danger' : 'kpi-value--green'">{{ productosEanDuplicado.length }}</span>
        <span class="kpi-foot">EAN compartidos</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Variantes</span>
        <span class="kpi-value">{{ totalVariantes }}</span>
        <span class="kpi-foot">afectadas</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Productos</span>
        <span class="kpi-value">{{ productosAll.length }}</span>
        <span class="kpi-foot">escaneados</span>
      </div>
    </div>

    <!-- Loading -->
    <div class="section-card" v-if="loading">
      <div class="loading-state">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>Cargando productos de Shopify...</span>
      </div>
    </div>

    <!-- Empty state -->
    <div class="section-card" v-else-if="productosEanDuplicado.length === 0">
      <div class="empty-state">
        <i class="fa-solid fa-circle-check"></i>
        <h4 class="empty-state__title">Sin duplicados</h4>
        <p class="empty-state__text">No se han encontrado EAN duplicados</p>
      </div>
    </div>

    <!-- Duplicates list -->
    <div v-else>
      <div class="dup-card" v-for="eanItem in productosEanDuplicado" :key="eanItem.ean">
        <div class="dup-card__header">
          <div class="dup-card__ean-badge">
            <i class="fa-solid fa-barcode"></i>
            {{ eanItem.ean }}
          </div>
          <span class="dup-card__count">{{ eanItem.products.length }} variantes</span>
        </div>

        <div class="dup-card__grid">
          <div class="variant-card" v-for="variantItem in eanItem.products" :key="variantItem.variant.id">
            <div class="variant-card__img-wrap">
              <img
                v-if="variantItem.variant.image_id"
                :src="getVariantImage(variantItem)"
                class="variant-card__img"
              />
              <div v-else class="variant-card__img-empty">
                <i class="fa-solid fa-image"></i>
              </div>
            </div>

            <div class="variant-card__body">
              <a
                :href="`https://admin.shopify.com/store/struendo/products/${variantItem.product.id}/variants/${variantItem.variant.id}`"
                target="_blank"
                class="variant-card__title"
              >
                {{ variantItem.product.title }}
              </a>
              <span class="variant-card__sku">{{ variantItem.variant.sku }}</span>
            </div>

            <div class="variant-card__footer">
              <button
                v-if="variantItem.variant.barcode != ''"
                class="btn-clean"
                @click="limpiarEan(variantItem)"
              >
                <i class="fa-solid fa-eraser"></i> Limpiar EAN
              </button>
              <span v-else class="cleaned-badge">
                <i class="fa-solid fa-check"></i> Limpiado
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'
import BCardCode from '@core/components/b-card-code'
import { BRow, BCol, BFormFile, BButton, BSpinner } from 'bootstrap-vue'
import { BTable } from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import * as XLSX from 'xlsx';

export default {
  components: {
    BCardCode, BRow, BCol, BFormFile, BButton, BSpinner, vSelect, BTable, ToastificationContent,
  },
  data() {
    return {
      productosAll: [],
      productosEanDuplicado: [],
      loading: false
    }
  },
  computed: {
    totalVariantes() {
      let count = 0;
      this.productosEanDuplicado.forEach(item => { count += item.products.length; });
      return count;
    }
  },
  methods: {
    loadItems() {
      axios.post("/uso", { seccion: "ean-duplicados" });
      this.loading = true;

      Promise.all([axios.get("/shopify/products")])
        .then(([productsResponse]) => {
          this.productosAll = productsResponse.data;

          const excludedSkus = ["COURIER-FEE","DEBOSS-CUSTOMIZATION","E-GIFT-CARD-300","GIFT-PACKAGING","LEATHER-CUSTOMIZATION"];

          const eanCount = {};
          this.productosAll.forEach(product => {
            product.variants.forEach(variant => {
              if (variant.barcode && !excludedSkus.includes(variant.sku) && variant.sku != null && variant.sku.length > 1) {
                eanCount[variant.barcode] = (eanCount[variant.barcode] || 0) + 1;
              }
            });
          });

          const eanDuplicadosMap = {};
          this.productosAll.forEach(product => {
            product.variants.forEach(variant => {
              if (variant.barcode && eanCount[variant.barcode] > 1 && !excludedSkus.includes(variant.sku) && variant.sku != null && variant.sku.length > 1) {
                if (!eanDuplicadosMap[variant.barcode]) eanDuplicadosMap[variant.barcode] = [];
                eanDuplicadosMap[variant.barcode].push({ product, variant });
              }
            });
          });

          this.productosEanDuplicado = Object.entries(eanDuplicadosMap).map(([ean, products]) => ({ ean, products }));
          this.loading = false;
        })
        .catch(error => {
          console.error("Error fetching data:", error);
          this.loading = false;
        });
    },
    getVariantImage(variantItem) {
      const image = variantItem.product.images.find(img => img.id === variantItem.variant.image_id);
      return image ? image.src : '';
    },
    async limpiarEan(variantItem) {
      let originalBarcode = variantItem.variant.barcode;
      variantItem.variant.barcode = '';

      const payload = {
        products: [{
          productId: variantItem.product.admin_graphql_api_id,
          variantId: variantItem.variant.admin_graphql_api_id,
          number: ''
        }]
      };

      axios.post("/shopify/products/barcode", payload)
        .then(response => response.data)
        .then(res => {
          if (res.errors) {
            this.$swal({ icon: "error", title: "Error en Shopify al limpiar el EAN", toast: true, position: "top-end", showConfirmButton: false, timer: 2000, timerProgressBar: true });
          } else {
            this.$swal({ icon: "success", title: "EAN limpiado correctamente", toast: true, position: "top-end", showConfirmButton: false, timer: 2000, timerProgressBar: true });
          }
        })
        .catch(error => {
          this.$swal({ icon: "error", title: "Error al limpiar el EAN", toast: true, position: "top-end", showConfirmButton: false, timer: 2000, timerProgressBar: true });
          variantItem.variant.barcode = originalBarcode;
        });
    },
  },
  mounted() { this.loadItems(); },
}
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$success: #10B981;
$danger: #EF4444;
$warning: #F59E0B;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.eandup-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 8px;
}

.ed-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
}

.header-eyebrow {
  display: block;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: $primary;
  margin-bottom: 2px;
}

.header-title {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: $text;
  margin: 0;
}

// KPI
.kpi-strip {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.kpi-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius-sm;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  box-shadow: $shadow;
}

.kpi-label { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: $text-muted; }
.kpi-value { font-family: 'JetBrains Mono', monospace; font-size: 22px; font-weight: 700; color: $text; font-feature-settings: "tnum"; margin: 4px 0 2px; &--danger { color: $danger; } &--green { color: $success; } }
.kpi-foot { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: $text-muted; }

// Section card
.section-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  overflow: hidden;
  margin-bottom: 16px;
}

// Loading
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 60px 0;
  color: $primary;

  i { font-size: 28px; }
  span { font-family: 'JetBrains Mono', monospace; font-size: 13px; color: $text-muted; }
}

// Empty
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 60px 0;
  text-align: center;

  i { font-size: 40px; color: $success; }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: $text;
    margin: 8px 0 0;
  }

  &__text {
    font-family: 'JetBrains Mono', monospace;
    font-size: 13px;
    color: $text-muted;
    margin: 0;
  }
}

// Duplicate card
.dup-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  overflow: hidden;
  margin-bottom: 16px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 22px;
    border-bottom: 1px solid $border;
  }

  &__ean-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    border-radius: 8px;
    background: rgba($danger, 0.06);
    border: 1px solid rgba($danger, 0.15);
    font-family: 'JetBrains Mono', monospace;
    font-size: 14px;
    font-weight: 700;
    color: $danger;
    font-feature-settings: "tnum";

    i { font-size: 14px; }
  }

  &__count {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: $text-muted;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 16px;
    padding: 20px 22px;
  }
}

// Variant card
.variant-card {
  background: $bg;
  border: 1px solid $border;
  border-radius: $radius-sm;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  }

  &__img-wrap {
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-bottom: 1px solid $border;
  }

  &__img {
    max-height: 140px;
    max-width: 90%;
    object-fit: contain;
  }

  &__img-empty {
    color: #CBD5E1;
    font-size: 32px;
  }

  &__body {
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: $text;
    text-decoration: none;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    &:hover { color: $primary; }
  }

  &__sku {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: $text-muted;
    word-break: break-all;
  }

  &__footer {
    padding: 0 16px 14px;
  }
}

.btn-clean {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: $radius-sm;
  border: 1px solid rgba($danger, 0.3);
  background: transparent;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: $danger;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: rgba($danger, 0.06);
  }
}

.cleaned-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 20px;
  background: rgba($success, 0.1);
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  color: $success;
}

// Responsive
@media (max-width: 768px) {
  .kpi-strip { grid-template-columns: 1fr; }
  .dup-card__grid { grid-template-columns: 1fr; }
}
</style>

<style lang="scss">
// Dark mode
.dark-layout {
  .eandup-page {
    .header-title { color: #E2E8F0; }
    .kpi-card { background: #1E293B; border-color: #334155; }
    .kpi-value { color: #F1F5F9; }

    .section-card { background: #1E293B; border-color: #334155; }
    .empty-state__title { color: #E2E8F0; }

    .dup-card { background: #1E293B; border-color: #334155; }
    .dup-card__header { border-color: #334155; }
    .dup-card__ean-badge { background: rgba(#EF4444, 0.08); border-color: rgba(#EF4444, 0.2); }

    .variant-card { background: #0F172A; border-color: #334155; }
    .variant-card__img-wrap { background: #1E293B; border-color: #334155; }
    .variant-card__title { color: #E2E8F0; &:hover { color: #3B82F6; } }
    .variant-card__sku { color: #64748B; }

    .btn-clean { border-color: rgba(#EF4444, 0.3); color: #EF4444; &:hover { background: rgba(#EF4444, 0.08); } }
  }
}
</style>
